<template>
  <ul class="tip danger" v-if="datalist.length > 0">
    <li v-for="(item, index) in datalist" :key="index">
      <div>
        <label>{{ item.Reviewer.Name }} {{ item.StateText }}</label>
        <label class="text-space text-info" v-if="item.Response"> {{ item.Response }}</label>
      </div>
      <div v-if="item.State == 0">
        <el-link v-action="'/api/Audit/Complete'" type="primary" @click="onApprove(item)">审核</el-link>
        <el-link v-action="'/api/Audit/Delete'" type="info" @click="onDelete(item)">撤销</el-link>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      datalist: []
    }
  },
  props: {
    target: { type: String },
    mode: { type: String },
  },
  created () {
    this.loadData()
  },
  methods: {
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.organize.audit.list({
        mode: this.mode,
        target: this.target
      }).then((res) => {
        this.datalist = res.Items
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    //审核
    onApprove (row) {
      this.$prompt(null, '审核', {
        confirmButtonText: '同意',
        cancelButtonText: '拒绝',
        inputType: 'textarea',
        inputPlaceholder: '请填写审核意见...',
        distinguishCancelAndClose: true,
        callback: (action, { inputValue }) => {
          //判定
          let state = null
          switch (action) {
            case "confirm": {
              state = true
              break
            }
            case "cancel": {
              state = false
              break
            }
          }
          //提交
          if (state !== null) {
            this.$apis.organize.audit.complete({
              Id: row.Id,
              State: state,
              Response: inputValue
            }).then(() => {
              this.loadData()
            }).catch((e) => {
              this.$message.error(e || "系统错误")
            })
          }
        }
      })
    },
    //删除
    onDelete (row) {
      this.$confirm(`此操作将移除请示信息, 是否继续?`, `删除`, {
        center: true,
      }).then(() => {
        this.$apis.organize.audit.delete({ id: row.Id }).then(() => {
          this.loadData()
        }).catch((e) => {
          this.$message.error(e || "系统错误")
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
ul.tip {
  li {
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}
</style>